import React from "react";
import "./AdminDashboardHome.css";

export default function ModuleCard({ icon, title, description, count, accent = "primary", onClick }) {
  return (
    <button type="button" className={`adh-module-card adh-module-${accent}`} onClick={onClick}>
      <span className="adh-module-icon">
        <i className={`fa-solid ${icon}`} aria-hidden="true"></i>
      </span>
      <span className="adh-module-body">
        <span className="adh-module-title-row">
          <span className="adh-module-title">{title}</span>
          {(count || count === 0) && <span className="adh-module-count">{count}</span>}
        </span>
        <span className="adh-module-desc">{description}</span>
      </span>
      <i className="fa-solid fa-arrow-right adh-module-arrow" aria-hidden="true"></i>
    </button>
  );
}
